import React from 'react';
import classnames from 'classnames';
import { mathRound } from '@gp/utils/common';

import type { IBaseProps } from '@home/types/common';
import type { IFeeUpdatedHistory } from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';

interface IFeeUpdatedHistoriesBubbleProps extends IBaseProps {
  histories?: IFeeUpdatedHistory[] | null;
}

const FeeUpdatedHistoriesBubble: React.FC<IFeeUpdatedHistoriesBubbleProps> = (props) => {
  const { style, className, histories } = props;

  return (
    <div style={style} className={classnames('dbg-milestone-history-bubble', className)}>
      {histories?.map((history, historyIdx) => {
        const historyAmount = history?.amount?.trim();
        const showAmount = !!historyAmount;
        const amountText = !showAmount ? '-' : `${mathRound(historyAmount)}&nbsp;M$`;
        return (
          <div key={historyIdx} className="dbg-milestone-history-bubble-item">
            <div className="dbg-milestone-history-bubble-num" dangerouslySetInnerHTML={{ __html: amountText }}></div>
            <div className="dbg-milestone-history-bubble-text">
              <div className="dbg-milestone-history-bubble-name">{history?.modify_personnel || '-'}</div>
              <div>{history?.update_time || '-'}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FeeUpdatedHistoriesBubble;
